<template>
    <div v-if="formattedFrom && formattedTo" class="d-flex">
        <div class="mr-3 flex-all">
            <label v-if="fromLabel">{{ fromLabel }}</label>
            <vue-datepicker
                :value="formattedFrom"
                @selected="setFrom"
                :monday-first="false"
                wrapper-class="date-input"
                format="yyyy-MM-dd"
                :required="false">
            </vue-datepicker>
        </div>

        <div class="flex-all">
            <label v-if="toLabel">{{ toLabel }}</label>
            <vue-datepicker
                :value="formattedTo"
                @selected="setTo"
                :monday-first="false"
                wrapper-class="date-input"
                format="yyyy-MM-dd"
                :disabled="{ to: disabledTo }"
                :required="false">
            </vue-datepicker>
        </div>
    </div>
</template>

<script>
    import VueDatepicker from 'vuejs-datepicker'

    export default {
        props: {
            from: Object,
            to: Object,
            disabledFrom: {
                type: Date,
                required: false,
            },
            disabledTo: {
                type: Date,
                required: false,
            },
            fromLabel: {
                type: String,
                required: false,
            },
            toLabel: {
                type: String,
                required: false,
            }
        },
        computed: {
            formattedFrom: function() {
                return this.formatDate(this.from);
            },
            formattedTo: function() {
                return this.formatDate(this.to);
            },
        },
        methods: {
            setFrom: function(date) {
                this.$emit('setFrom', date);
            },
            setTo: function(date) {
                this.$emit('setTo', date);
            }
        },
        components: {
            VueDatepicker,
        }
    }
</script>



// WEBPACK FOOTER //
// DateRange.vue?9f2d9472